<template>
  <v-row>
    <v-col cols="12" sm="6">
      <v-card outlined class="rounded-card">
        <v-subheader>Local de entrega</v-subheader>
        <v-divider/>
        <v-card-text>
          <px-detalhes-comprador :comprador="requisicao.compradorEntrega"/>
        </v-card-text>
      </v-card>
    </v-col>
    <v-col cols="12" sm="6">
      <v-card outlined class="rounded-card">
        <v-subheader>Local de faturamento</v-subheader>
        <v-divider/>
        <v-card-text>
          <px-detalhes-comprador :comprador="requisicao.comprador"/>
        </v-card-text>
      </v-card>
    </v-col>
  </v-row>
</template>

<script>
export default {
  props: {
    requisicao: {
      type: Object,
      required: true,
    },
  },
};
</script>
